import {buildApiUrl} from "./axiosClient";

export function getLoginUrl() {
  return buildApiUrl(process.env.REACT_APP_LOGIN_PAGE);
}

export function getLogoutUrl() {
  return buildApiUrl(process.env.REACT_APP_LOGOUT_PAGE);
}
